import Experience from './FactoryExperience/Experience.js';
import './factory.css';

window.experience = new Experience({
  targetElement: document.querySelector('.experience')
});

window.onpopstate = function () {
  experience.camera.logic.buttonsLocked = false;
  switch (window.location.hash) {
    case '':
      experience.camera.camControls.toDefault();
      break;
    case '#skills':
      experience.camera.camControls.toSkills();
      break;
    case '#projects':
      experience.camera.camControls.toProjects();
      break;
    case '#contact':
      experience.camera.camControls.toContact();
      break;
    default:
      break;
  }
};
